/**
 * @file remove-draft-product.tsx
 * @module app/modals/remove-draft-product
 * @description Renders the remove draft product modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Modal, Button } from 'react-bootstrap';
import CrossSvg from '../../_admin/assets/media/close.png';
import { useState } from 'react';
import APICallService from '../../api/apiCallService';
import { product } from '../../api/apiEndPoints';
import { warehouse as warehouseStoreString } from '../../utils/storeString';
import { getKey } from '../../Global/history';
import Method from '../../utils/methods';
import { useAuth } from '../modules/auth';
import { useWarehouse } from '../context/WarehouseContext';
const RemoveDraftProduct = (props: any) => {
   const {currentUser} = useAuth();
  
  const { selectedWarehouse } = useWarehouse();
  const [loading, setLoading] = useState(false);
  const deleteDraftProduct = async () => {
    setLoading(true);
    let apiService = new APICallService(product.deleteProduct, props.deleteId,'','','','',props.moduleName,selectedWarehouse?.value || null);
    let response = await apiService.callAPI();
    if (response) {
      props.handleDraftCount();
      props.onHide();
       
    }
    setLoading(false);
  };
  return (
    <>
      <Modal
        {...props}
        show={props.show}
        onHide={props.onHide}
        dialogClassName="modal-dialog-centered min-w-lg-590px"
        className="border-r10px"
        centered
        backdrop="static"
      >
        <Modal.Header className="border-bottom-0 pb-0 text-center mx-auto">
          <img
            className="close-inner-top"
            width={40}
            height={40}
            src={CrossSvg}
            alt="closebutton"
            onClick={props.onHide}
          />
          <Modal.Title className="fs-26 fw-bolder mw-lg-375px pt-lg-3">
            Are you sure you want to remove{' '}
            {props.title.replace(/\s*\)\s*/g, ')')}?
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer className="justify-content-center mt-2 mb-4 border-top-0">
          <Button className="uw-btn uw-btn-danger uw-btn-lg"
            variant="danger"
            size="lg"
            onClick={deleteDraftProduct}
            disabled={loading}
          >
            {!loading && (
              <span className="indicator-label">Yes, remove from draft</span>
            )}
            {loading && (
              <span
                className="indicator-progress"
                style={{ display: 'block' }}
              >
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default RemoveDraftProduct;
